(function () {
    'use strict';
    var app = angular.module('app');

    app.service('swaggerOperationModelFactory', [swaggerOperationModelFactory]);
    function swaggerOperationModelFactory(form, resource, operation, swagger) {

        this.convertToSwaggerOperations = convertToSwaggerOperations;

        function convertToSwaggerOperations(forms, resources, swagger) {
            var swaggerOperations = [];
            for (var resourceIndex in resources) {
                var resource = resources[resourceIndex];
                for (var operationIndex in resource.operations) {
                    var operation = resource.operations[operationIndex];
                    var form = forms[operation.id];
                    swaggerOperations.push(new SwaggerOperation(form, resource, operation, swagger));
                }
            }
            return swaggerOperations;
        }


        function SwaggerOperation(form, resource, operation, swagger) {
            this.form = form;
            this.resource = resource;
            this.operation = operation;
            this.swagger = swagger;
        }

    }
})();